import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { UserService } from '@app/user/services';
import { PATHS } from '@shared/constants/paths';
import { combineLatest, map, take } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MppResolverService {
  constructor(
    private userService: UserService,
    private router: Router,
  ) {}

  resolve(route: ActivatedRouteSnapshot, state?: RouterStateSnapshot): any {
    this.userService.showMPPMoxe.pipe(take(1)).subscribe(canProceed => {
      if (!canProceed) {
        this.router.navigate([PATHS.HOME]);
      }
    });
  }
}
